
const Image = ({
	name = "",
	image: {
		url = "",
		title = "",
		alt = title,
		width = null,
		height = null,
		baseClass = "",
		loading = "lazy",
		fetchpriority = "auto",
		decoding = "auto",
	} = {},
}) => {
	const modifier = name ? `${baseClass}--${name}` : "";

	if (!url) {
		return null;
	}

	return (
		<img
			className={`${baseClass} ${modifier}`}
			src={url}
			alt={alt}
			title={title}
			width={width}
			height={height}
			loading={loading}
			fetchpriority={fetchpriority}
			decoding={decoding}
		/>
	);
};

export default Image;
